<script>
  export let exercises

  import { createEventDispatcher } from 'svelte'

  let exercise = {
    execution_type: 'count_based',
    amount: 10,
    exercise: {},
  }

  const dispatch = createEventDispatcher()

  function handleOnSubmit() {
    if (!exercise.exercise.url || exercise.amount <= 0) {
      // Not valid
      return
    }

    // Hack: Until here, only the exercise.exercise.url is updated, the rest of exercise.exercise is still the original exercise
    // Update the whole exercise.exercise
    exercise.exercise = exercises.filter(
      (e) => e.url == exercise.exercise.url
    )[0]

    dispatch('saveExercise', exercise)
  }

  function abortEditMode() {
    dispatch('abortEdit', {})
  }
</script>

<li class="list-group-item">
  <form on:submit|preventDefault={handleOnSubmit}>
    <div class="input-group mb-2">
      <input
        type="text"
        name="amount"
        bind:value={exercise.amount}
        class="form-control"
        placeholder="Recipient's username"
      />
      <select
        class="form-select"
        name="execution_type"
        bind:value={exercise.execution_type}
      >
        <option value="count_based">Times</option>
        <option value="time_based">Seconds</option>
      </select>
    </div>

    <select
      class="form-select"
      name="exercise"
      bind:value={exercise.exercise.url}
    >
      {#each exercises as bex (bex.id)}
        <option value={bex.url}>{bex.name}</option>
      {/each}
    </select>

    <div class="btn-group d-flex pt-2" role="group">
      <button type="submit" class="btn btn-primary btn-sm"
        ><i class="bi bi-save" /> Add Exercise</button
      >
      <button
        type="button"
        class="btn btn-secondary btn-sm"
        on:click={abortEditMode}><i class="bi bi-x" /> Abort</button
      >
    </div>
  </form>
</li>
